import type { ScheduledOptimistInfo } from "@gearbox-protocol/deploy-tools-shared";
import { cn, NetworkLogo } from "@gearbox-protocol/deploy-tools-ui";
import { chains } from "@gearbox-protocol/sdk/onchain";
import { formatDistanceToNow } from "date-fns";
import type { FC } from "react";
import { Link, useLoaderData } from "react-router-dom";

const OptimistRootRoute: FC = () => {
  const list = useLoaderData() as ScheduledOptimistInfo[];
  return (
    <div>
      <h2>Latest executions</h2>
      <div className="mt-2 grid grid-cols-[max-content_max-content_max-content] gap-x-4 gap-y-2">
        {list.map(el => (
          <ScheduledOptimistItem key={el.executionId} info={el} />
        ))}
      </div>
    </div>
  );
};

const ScheduledOptimistItem: FC<{ info: ScheduledOptimistInfo }> = ({
  info,
}) => {
  const date = new Date(info.finishedAt);
  const isTooOld = date.getTime() < Date.now() - 1000 * 60 * 60 * 6; // 6 hours
  const isFailed = info.status === "failed" || info.failed > 0;
  const success = info.status === "success" ? info.discovered - info.failed : 0;
  return (
    <Link to={`${info.executionId}`} target="_blank" className="contents">
      <div className="flex items-center gap-x-2">
        <NetworkLogo chainId={chains[info.network].id} />
        <span className={cn({ "text-red-500": isTooOld || isFailed })}>
          {info.network}
        </span>
      </div>

      <div className="flex items-center">
        {info.status === "success" ? (
          <span
            className={cn("font-mono", { "text-red-500": isFailed })}
          >{`${success}/${info.discovered}`}</span>
        ) : (
          <span className="text-red-500 font-mono">failed</span>
        )}
      </div>

      <div className="flex items-center">
        <span
          className={cn("text-sm text-slate-400", {
            "text-red-500": isTooOld,
          })}
        >
          {formatDistanceToNow(date, { addSuffix: true })}
        </span>
      </div>
    </Link>
  );
};

export default OptimistRootRoute;
